import $ from 'jquery';
import { dataLayerEventExist } from '../site/helpers';

class ExpertiseFilter {
  constructor(selector) {
    this.container = $(selector);
    this.items = this.container.find('.filter-item');

    this._setListeners();
  }

  _setListeners() {
    this.items.on('click', (event) => this._handleItemClick(event));
  }

  _handleItemClick(event) {
    const target = $(event.currentTarget);
    const buttonText = event.target.innerText;

    // Remove 'active' class from all items
    this.items.removeClass('active');

    // Add 'active' class to the clicked item
    target.addClass('active');

    // GTM
    if (!dataLayerEventExist('expertiseCategoryClick', buttonText)) {
      window.dataLayer.push({
        event: 'expertiseCategoryClick',
        eventLabel: buttonText
      });
    }
  }
}

const expertiseFilter = (selector) => {
  $(selector).each((index, element) => {
    new ExpertiseFilter(element);
  });
};

export default expertiseFilter;
